import { Component } from 'react';
import styled from 'styled-components';

import InputContainer, { FormInput } from '../Input';

import { COLORS } from '../../../helpers/constants/styleguide';

/**
 * @typedef {Object} TextInputOwnProps
 * @property {string | number} [value]
 * @property {(event: React.ChangeEvent<HTMLInputElement>) => void} [onChange]
 * @property {(event: React.FocusEvent<HTMLInputElement>) => void} [onBlur]
 * @property {(event: React.FocusEvent<HTMLInputElement>) => void} [onFocus]
 * @property {(event: React.KeyboardEvent<HTMLInputElement>) => void} [onKeyPress]
 * @property {string} [placeholder]
 * @property {string} [type]
 * @property {string} [autoComplete]
 * @property {'text' | 'numeric' | 'decimal' | 'tel' | 'email' | 'url' | 'search' | 'none'} [inputMode]
 * @property {number} [maxLength]
 * @property {boolean} [disabled]
 * @property {boolean} [readOnly]
 * @property {boolean} [noFormik] Render a bare input rather than a Formik Field
 */

/** @typedef {import('../Input').InputFieldProps} InputFieldProps */
/** @typedef {InputFieldProps & TextInputOwnProps} TextInputProps */

/** @extends {Component<TextInputProps>} */
class TextInput extends Component {
  static defaultProps = {
    disabled: false,
    type: 'text',
    onFocus: () => {},
    onBlur: () => {},
    placeholder: '',
  };

  renderInputText = (handleFocusChange, focus, { inputId, labelId }) => {
    const {
      placeholder,
      onChange,
      value,
      name,
      maxLength,
      onBlur,
      type,
      disabled,
      validate,
      autoComplete,
      readOnly,
      inputMode = 'text',
      noFormik,
      onKeyPress,
      onFocus,
      subTitle,
    } = this.props;

    return (
      <Input
        id={inputId}
        aria-labelledby={labelId}
        as={noFormik && 'input'}
        inputMode={inputMode}
        type={type}
        name={name}
        maxLength={maxLength}
        validate={validate}
        value={value}
        placeholder={placeholder}
        subTitle={subTitle}
        onChange={onChange}
        onFocus={e => {
          handleFocusChange();
          onFocus(e);
        }}
        disabled={disabled}
        autoComplete={autoComplete}
        readOnly={readOnly}
        onKeyPress={onKeyPress}
        onBlur={e => {
          handleFocusChange();
          onBlur(e);
        }}
      />
    );
  };

  render() {
    const {
      error,
      touched,
      height,
      isSubmitting,
      label,
      subTitle,
      helpMessage,
      name,
    } = this.props;
    return (
      <InputContainer
        id={name}
        error={error}
        touched={touched}
        height={height}
        isSubmitting={isSubmitting}
        label={label}
        subTitle={subTitle}
        helpMessage={helpMessage}
      >
        {this.renderInputText}
      </InputContainer>
    );
  }
}

const Input = styled(FormInput)`
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  margin: auto 0;
  caret-color: ${COLORS.darkerGrey};

  &:focus {
    outline: none;
  }
`;

export default TextInput;
